import MobileMenuGroupItem from './mobile-menu-group-item'

export default MobileMenuGroupItem
